import { EntityId } from "@reduxjs/toolkit";

import { streamingApi } from "./base.api";
import { Incident } from "types/Incident";

const BASE_PATH = "/cai-portal";

export const caiPortalApi = streamingApi.injectEndpoints({
    endpoints: (build) => ({
        getIncidents: build.query<
            Incident[],
            {
                siteId: EntityId;
                incidentTime: string;
            }
        >({
            query: (payload) => {
                return `${BASE_PATH}/Sites/${payload.siteId}/Incidents?incidentTime=${encodeURIComponent(payload.incidentTime)}`;
            },
        }),
    }),
    overrideExisting: true,
});

export const { useGetIncidentsQuery } = caiPortalApi;
